const overview = {
	add: "Create VPS",
	empty_list: {
		title: "You don't have any VPS yet",
	},
	notifications: {
		create:
			"Your VPS <strong>{{name}}</strong> is being created, it may take a while before it is visible.",
		delete:
			"Your VPS <strong>{{name}}</strong> has been successfully deleted, it may take a while before this is visible.",
		network_already_existing:
			"Private network <strong>{{name}}</strong> cannot be created. This name is already in use.",
		no_network: "Your VPS has no public or private networks configured. Add at least one of them.",
	},
	search_input: "Search VPS",
	service_unavailable: {
		button: "Reload Page",
		description: "Please try again later.",
		title: "The service is currently unavailable.",
	},
	title: "VPS overview",
};

export default overview;
